import { render, staticRenderFns } from "./SidebarF.vue?vue&type=template&id=d570d704"
import script from "./SidebarF.vue?vue&type=script&lang=js"
export * from "./SidebarF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports